import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import intlTelInput from 'intl-tel-input';

@Component({
  selector: 'angular-four-dot-five-phone-number',
  templateUrl: './four-dot-five-phone-number.component.html',
  styleUrls: ['./four-dot-five-phone-number.component.css'],
  viewProviders: [{
    provide: ControlContainer,
    useFactory: (ngForm: NgForm) => ngForm,
    deps: [[new Optional(), new SkipSelf(), NgForm]]
  }]
})
export class FourDotFivePhoneNumberComponent implements OnInit, OnDestroy {

  @Input() elementId;
  @Input() valueField;
  @Input() isRequired = true;
  @Input() readOnly;
  @Output() valueFieldChange = new EventEmitter<any>();
  @Output() isPhoneNumberInvalid = new EventEmitter<boolean>();
  @Output() phoneNumberFormat = new EventEmitter<any>();

  setInitialCountry:any = '';
  private pendingTimeouts: any[] = [];

  constructor() { }

  private isInitialized(): boolean {
    const $el = $(`#${this.elementId}`) as any;
    return $el.length > 0 && !!$el.data('plugin_intlTelInput');
  }

  ngOnInit() {

    if(this.readOnly && !this.valueField) {
      this.setInitialCountry = "auto";
    } else {
      this.setInitialCountry = "us";
    }

    this.pendingTimeouts.push(setTimeout(() => {
      if ($(`#${this.elementId}`).length === 0) {
        return;
      }
      ($(`#${this.elementId}`) as any).intlTelInput({
        initialCountry: this.setInitialCountry,
        formatOnDisplay: true,
        utilsScript: 'assets/app-content/js/utils.js'
      });
    }, 100));

    this.pendingTimeouts.push(setTimeout(() => {
      if (!this.isInitialized()) {
        return;
      }

      if (!_.isNull(this.valueField) && !_.isUndefined(this.valueField)) {
        ($(`#${this.elementId}`) as any).intlTelInput("setNumber", this.valueField);
      }

      if (_.isNull(document.getElementById(this.elementId))) {
        let phoneNumberFormat = "";
        this.phoneNumberFormat.emit(phoneNumberFormat);
      } else {
        let phoneNumberFormat = document.getElementById(this.elementId).getAttribute('placeholder');
        this.phoneNumberFormat.emit(phoneNumberFormat);
      }

      // set up the handler for country change
      $(`#${this.elementId}`).on('countrychange', (e, countryData) => {
        this.pendingTimeouts.push(setTimeout(() => {
          if (!this.isInitialized()) {
            return;
          }

          if (!_.isNull(this.valueField)) {
            this.valueField = ($(`#${this.elementId}`) as any).intlTelInput("getNumber");
            ($(`#${this.elementId}`) as any).intlTelInput("setNumber", this.valueField);
          }

          let phoneNumberFormat = document.getElementById(this.elementId).getAttribute('placeholder');
          this.phoneNumberFormat.emit(phoneNumberFormat);

        }, 100));
      });
      this.phoneNumberChanged();
    }, 1000));

  }

  phoneNumberChanged() {
    // Runs synchronously (previously deferred via setTimeout) so the emitted
    // isPhoneNumberInvalid/valueFieldChange values are up to date before a
    // Next/Save click handler on the parent form reads them - the (change)
    // event that triggers this already fires after the plugin/DOM have
    // updated, so no further delay is needed, and deferring it created a race
    // where clicking Next read the still-stale (invalid/required) flag.
    if (!this.isInitialized()) {
      return;
    }

    // initialCountry "auto" leaves no selected country until the geo-IP lookup
    // returns, and getNumber throws on dialCode while it is unset (the data is `{}`, not null).
    const selectedCountry = ($(`#${this.elementId}`) as any).intlTelInput("getSelectedCountryData");
    if (!selectedCountry || !selectedCountry.dialCode) {
      return;
    }

    this.valueField = ($(`#${this.elementId}`) as any).intlTelInput("getNumber");
    ($(`#${this.elementId}`) as any).intlTelInput("setNumber", this.valueField);

    this.valueFieldChange.emit(this.valueField);
    // Check Valid Phone Number
    if (!($(`#${this.elementId}`) as any).intlTelInput("isValidNumber")) {
      this.isPhoneNumberInvalid.emit(true);
    } else {
      this.isPhoneNumberInvalid.emit(false);
    }
  }

  ngOnDestroy() {
    this.pendingTimeouts.forEach(t => clearTimeout(t));
    if (this.isInitialized()) {
      ($(`#${this.elementId}`) as any).intlTelInput("destroy");
    }
  }

}
